import {toast} from "react-toastify";

const options={
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    draggable: true,
    progress: undefined,
}

export class ToastHelper {

    static success(msg, extraOptions={}) {
        return (toast.success(msg, {...options, ...extraOptions}))
    }

    static error(msg, extraOptions={}) {
        return (toast.error(msg, {...options, ...extraOptions}))
    }

    static info(msg, extraOptions={}) {
        return (toast.info(msg, {...options, ...extraOptions}))
    }

}